package com.dotdrives.repository

import com.dotdrives.client.ReminderClient
import com.dotdrives.model.NewReminder
import com.dotdrives.model.ReminderFilter
import com.dotdrives.model.ReminderSubjectOption
import com.dotdrives.model.ReminderSummary
import kotlin.time.Instant

interface ReminderRepository {
    suspend fun list(orgId: String, filter: ReminderFilter, currentUserId: String): Result<List<ReminderSummary>>

    suspend fun searchSubjects(orgId: String, query: String): Result<List<ReminderSubjectOption>>

    suspend fun create(orgId: String, reminder: NewReminder): Result<ReminderSummary>

    suspend fun complete(orgId: String, reminderId: String): Result<Unit>

    suspend fun snooze(orgId: String, reminderId: String, dueAt: Instant): Result<Unit>

    suspend fun reassign(orgId: String, reminderId: String, userId: String): Result<Unit>
}

class SupabaseReminderRepository(
    private val client: ReminderClient = ReminderClient(),
) : ReminderRepository {
    override suspend fun list(
        orgId: String,
        filter: ReminderFilter,
        currentUserId: String,
    ): Result<List<ReminderSummary>> =
        runCatching { client.list(orgId, filter, currentUserId) }

    override suspend fun searchSubjects(orgId: String, query: String): Result<List<ReminderSubjectOption>> =
        runCatching { client.searchSubjects(orgId, query) }

    override suspend fun create(orgId: String, reminder: NewReminder): Result<ReminderSummary> =
        runCatching { client.create(orgId, reminder) }

    override suspend fun complete(orgId: String, reminderId: String): Result<Unit> =
        runCatching { client.complete(orgId, reminderId) }

    override suspend fun snooze(orgId: String, reminderId: String, dueAt: Instant): Result<Unit> =
        runCatching { client.snooze(orgId, reminderId, dueAt) }

    override suspend fun reassign(orgId: String, reminderId: String, userId: String): Result<Unit> =
        runCatching { client.reassign(orgId, reminderId, userId) }
}
